import React from "react";
import type {DeserializedGridCellParams} from "../../../../../../components/muix-data-grid/MuiXColumnDefinitions.ts";
import type {PartGridRowModel} from "../CategorizationTableDataModel.ts";
import {Tooltip, Typography} from "@mui/material";

export const ReasoningCell: React.FC<DeserializedGridCellParams<PartGridRowModel>> = ({value}) => {
    if (!value) return <></>
    return <Tooltip arrow title={value} enterTouchDelay={0} leaveTouchDelay={3000}>
        <Typography
            fontSize={13}
            color="text.main"
            sx={{
                display: 'block',
                height: '100%',
                maxHeight: '100%',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                minWidth: 0,
                maxWidth: '100%',
                lineHeight: 'normal',
                alignContent: 'center',
            }}
        >
            {value}
        </Typography>
    </Tooltip>
}
